/**
 * Sanitizes the markdown string generated by RichEditor to remove the escape characters for empty lines.
 * @param str markdown string
 * @returns sanitized string
 */
export function sanitizeMarkdownString(str: string | null | undefined): string {
	return (str ?? '')
		.replaceAll('\\', '')
		.split('\n')
		.map((line) => {
			const regex = /( {0,}#{1,}.*) \{#\}/;
			const match = regex.exec(line);
			return match ? match[1] : line;
		})
		.join('\n');
}

export function escapeStringRegexp(text: string) {
	if (typeof text !== 'string') {
		return text;
	}

	return text.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

/**
 * Strips markdown links, converting `[text](url)` to `text`.
 */
export function stripMarkdownLinks(text: string | null | undefined): string {
	if (!text) return '';
	return text.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
}

/**
 * Trims empty lines from the start and end of the markdown string.
 * @param text markdown string
 * @returns trimmed string
 */
export function trimMarkdown(text: string | null | undefined) {
	if (!text) return '';
	// Split into lines, trim empty lines from start and end, then join back
	const lines = text.split('\n');
	const firstNonEmpty = lines.findIndex(
		(line) => line.trim() !== '' && line.trim() !== '\\'
	);
	const lastNonEmpty =
		lines.length -
		[...lines]
			.reverse()
			.findIndex((line) => line.trim() !== '' && line.trim() !== '\\');
	if (firstNonEmpty === -1) return '';
	const trimmedLines = lines.slice(firstNonEmpty, lastNonEmpty);
	return trimmedLines.join('\n');
}
